import { DaymapQuery as i } from "../daymapQuery.js";
var $;
((n) => {
  ((t) => {
    t[t.Resource = 1] = "Resource", t[t.Events = 2] = "Events", t[t.GroupEvents = 3] = "GroupEvents", t[t.Timetable = 4] = "Timetable", t[t.Records = 5] = "Records";
  })(n.CalendarTypeEnum || (n.CalendarTypeEnum = {})), ((t) => {
    t[t.None = 0] = "None", t[t.Time = 1] = "Time", t[t.TimetablePeriods = 2] = "TimetablePeriods", t[t.CalendarTimeSlots = 3] = "CalendarTimeSlots";
  })(n.ScheduleByEnum || (n.ScheduleByEnum = {}));
  class g extends i {
    constructor() {
      super(
        ["calendars"],
        {},
        "/lms/api/calendars/all",
        null,
        { stale: 1e3 * 60 * 10 }
        // 10 minutes
      );
    }
  }
  n.GetAllCalendars = g;
  class D extends i {
    constructor(e) {
      super(
        ["events", e.from, e.to, e.hiddenCalendarIds],
        e,
        `/lms/api/calendars/view/personal/combined?from=${e.from.toJSON()}&to=${e.to.toJSON()}&includeTimetable=false${e.hiddenCalendarIds ? `&hidden=${e.hiddenCalendarIds.join(",")}` : ""}`,
        null,
        {
          select: (a) => ({
            ...a,
            Events: a.Events.map((l) => ({
              ...l,
              Start: new Date(l.Start),
              Finish: new Date(l.Finish)
            }))
          }),
          stale: 1e3 * 60 * 1
          // 1 minute
        }
      );
    }
  }
  n.events = D;
  class S extends i {
    constructor(e) {
      let a = `/lms/api/calendars/diaryitems?from=${e.from.getFullYear()}-${(e.from.getMonth() + 1).toString().padStart(2, "0")}-${e.from.getDate().toString().padStart(2, "0")}`;
      e.to && (a += `&to=${e.to.getFullYear()}-${(e.to.getMonth() + 1).toString().padStart(2, "0")}-${e.to.getDate().toString().padStart(2, "0")}`), e.studentId && (a += `&studentID=${e.studentId ? e.studentId : 0}`), e.classId && (a += `&classID=${e.classId ? e.classId : 0}`), e.nonTimetableOnly && (a += "&nonTimetableOnly=true"), super(
        ["diaryitems", e.from, e.to, e.studentId, e.classId],
        e,
        a,
        null,
        {
          select: (l) => l.map((d) => ({ ...d, Start: new Date(d.Start), Finish: new Date(d.Finish) })),
          stale: 1e3 * 60 * 2
        }
      );
    }
  }
  n.DiaryItems = S;
  class v extends i {
    constructor(e) {
      super(
        ["event", e.eventID],
        e,
        `/lms/api/calendar/timetable/event/details?eventID=${e.eventID}&studentID=${e.studentID}`,
        null,
        { stale: 1e4, enabled: e.enabled }
      );
    }
  }
  n.EventDetails = v;
  class b extends i {
    constructor(e) {
      super(
        ["calendarevent", e],
        { id: e },
        `/lms/api/calendars/event/details?id=${e}`,
        null,
        { stale: 1e4 }
      );
    }
  }
  n.CalendarEventDetails = b;
  class w extends i {
    constructor(e) {
      super(
        ["dateranges"],
        e,
        "/lms/api/calendars/dateranges/currentandprevious",
        null,
        { stale: 1e3 * 60 }
        // 1 minute
      );
    }
  }
  n.DateRanges = w;
  class h extends i {
    constructor(e) {
      const { from: a, to: l, calendarMode: r = "personal", groupId: d, calendarId: c, hidden: u = [], includeTimetable: C = !1, includeOwner: O = !1, adminMode: M = !1, forContactID: f, enabled: R, includeAttendees: I } = e;
      let s = "/lms/api/calendars/view/";
      c ? s += `planner/single/?calendarId=${c}` : r === "grouped" && d ? (s += `planner/grouped/?groupId=${d}&hidden=${u.join(",")}`, M && (s += "&admin=1"), f && (s += `&contactId=${f}`)) : r === "planner" ? s += "planner/" : s += `${r}/combined/?hidden=${u.join(",")}&includeTimetable=${C}`, O && (s += "&includeOwner=1"), I && (s += "&includeAttendees=true");
      const T = `${a.getFullYear()}/${String(a.getMonth() + 1).padStart(2, "0")}/${String(a.getDate()).padStart(2, "0")}`, A = `${l.getFullYear()}/${String(l.getMonth() + 1).padStart(2, "0")}/${String(l.getDate()).padStart(2, "0")}`;
      s += `&from=${T}&to=${A}`, super(
        ["calendarview", r, a, l, d, c, I],
        e,
        s,
        null,
        {
          select: (m) => ({
            ...m,
            Events: m.Events.map((o) => ({
              ...o,
              Start: new Date(o.Start),
              Finish: new Date(o.Finish)
            }))
          }),
          stale: 1e3 * 60 * 2,
          // 2 minutes
          enabled: R
        }
      );
    }
  }
  n.CalendarView = h;
  class x extends i {
    constructor(e) {
      let a = `/lms/api/calendars/classlist?calId=${e.calId}`;
      e.staffId !== void 0 && (a += `&staffId=${e.staffId}`), e.from && (a += `&from=${e.from.toISOString()}`), e.to && (a += `&to=${e.to.toISOString()}`), super(
        ["classlist", e.calId, e.staffId, e.from, e.to],
        e,
        a,
        null,
        {
          stale: 1e3 * 60 * 2
          // 2 minutes
        }
      );
    }
  }
  n.ClassList = x;
  class F extends i {
    constructor(e) {
      super(
        ["calendarlist", e.groupId],
        e,
        `/lms/api/calendars/calendarlist${e.groupId ? `?groupId=${e.groupId}` : ""}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minute
      );
    }
  }
  n.CalendarList = F;
})($ || ($ = {}));
export {
  $ as calendars
};
//# sourceMappingURL=index.js.map
